import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { RouterModule } from '@angular/router';
import { GlobalModule } from '@app/core/global.module';
import { DynamicFieldsModule } from '@app/modules/dynamic-fields/dynamic-fields.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { PanelToolsModule } from '@components/panel-tools/panel-tools.module';
import { BackgroundColorOpacityDirective } from '@directives/background-color-opacity/background-color-opacity.directive';
import { FuiBadgeComponent, FuiButtonsPanelComponent } from '@fui/fui-components';
import { PanelTitleComponent } from './panel-title.component';

@NgModule({
    declarations: [PanelTitleComponent],
    exports: [PanelTitleComponent],
    imports: [
        BackgroundColorOpacityDirective,
        ButtonModule,
        FuiButtonsPanelComponent,
        CommonModule,
        FuiBadgeComponent,
        DynamicFieldsModule,
        GlobalModule,
        MatCardModule,
        PanelToolsModule,
        RouterModule,
    ],
})
export class PanelTitleModule {}
